import {IActionBase} from "./IActionBase";
import {Component} from "react";
import {store} from "../../redux/storeConfig/store";
import {utils_ui} from "../utils/utils_ui";
import {dataUtils} from "../js/dataUtils";
import {ActionsManager} from "./actionsManager";


export class action_AP_SetElementData extends Component implements IActionBase {

    actionCode = "action_AP_SetElementData";
    actionName = "action_AP_SetElementData";

    Execute = (prmActionParameters:any,prmActionsManager:ActionsManager, prmElementObj?:any)=> {
        let currLstElementsFlat = store.getState().store_PageStructure.lstElementsFlat;

        var elementObj;
        var lstElements: any[] = [];
        //comment: get Effected elements
        if (prmActionParameters.ElementType == 'tag') {
            lstElements = dataUtils.getElementsByElementTag(prmActionParameters.ElementIdentifier);

        }
        else if (prmActionParameters.ElementType == 'guid') {
            var elementObj = null
        currLstElementsFlat.map((currElement:any)=>{

            if(currElement.ElementGuid===prmActionParameters.ElementIdentifier){
                elementObj = currElement
            }
        })

            if (!!elementObj) {
                lstElements.push(elementObj);
            }
        }
        else if (prmActionParameters.ElementType == 'element') {

            let elementObj = dataUtils.getElementByClientID(prmActionParameters.ElementIdentifier);

            if (!!elementObj) {
                lstElements.push(elementObj);
            }

        }

        // //comment: set value into a temp var
        var currDataStr = utils_ui.getRelatedParamsForValue(prmActionParameters.Data);
        // currDataStr = APPLYOO.runtimeUtils.getRelatedParamsForValue(valueStr);
        // if (!!currDataStr
        //    && currDataStr.startsWith("@UrlParameter")) {
        //    var arrTemp = currDataStr.split("=");
        //
        //    if (arrTemp.length == 2) {
        //        var currUrlParams = APPLYOO.runtimeUtils.locationObj.search();
        //        currDataStr = currUrlParams[arrTemp[1]];
        //    }
        // }

        var value = undefined;
        switch (prmActionParameters.DataType) {

            case 'number':
                value = parseFloat(utils_ui.parseSystemValue(currDataStr));
                break;

            case 'string':
                value = utils_ui.parseSystemValue(currDataStr);
                break;

            case 'date':
                value = new Date(utils_ui.parseSystemValue(currDataStr));
                break;

            case 'boolean':
                value = utils_ui.parseSystemValue(currDataStr).toString().toLowerCase() == "true";
                break;
        }

        // //@SelectedProject.ProjectSettings.CurentBudgetYear.Value

        for (var ind01 = 0; ind01 < lstElements.length; ind01++) {
            var currElement = lstElements[ind01];

            utils_ui.setDataItem(currElement.DataBindStr, value, true);
        }

    }


}